export const GET_COUPONS_REQUEST = "GET_COUPONS_REQUEST"
export const GET_COUPONS_SUCCESS = "GET_COUPONS_SUCCESS"
export const GET_COUPONS_FAILURE = "GET_COUPONS_FAILURE"
export const GET_NEXT_PAGE_COUPONS_REQUEST = "GET_NEXT_PAGE_COUPONS_REQUEST"
